import {
  Calendar as PrimeCalendar,
  CalendarProps as PrimeCalendarProps,
} from "primereact/calendar";
import { classNames } from "primereact/utils";

interface CalendarProps {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  className?: string;
  id?: string;
  name?: string;
  value?: Date | Date[] | string | null;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  showIcon?: boolean;
  minDate?: Date;
  maxDate?: Date;
  rangeMode?: "single" | "multiple" | "range";
}

export function Calendar({
  label,
  placeholder,
  error,
  required,
  className,
  id,
  name,
  value,
  disabled,
  onChange,
  onBlur,
  showIcon = true,
  minDate,
  maxDate,
  rangeMode = "single",
}: CalendarProps) {
  const inputId = id || name;

  return (
    <div className="field">
      {label && (
        <label htmlFor={inputId} className="block mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <PrimeCalendar
        onChange={onChange}
        onBlur={onBlur}
        className={classNames("w-full", { "p-invalid": error }, className)}
        name={name}
        value={value as any}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        showIcon={showIcon}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={"dd/mm/yy"}
        selectionMode={rangeMode as PrimeCalendarProps["selectionMode"]}
      />
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
